import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function Status({ state }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.status}>
      <span className={styles.paragraph}>
        {t(`milestoneStatuses.${state}`, state)}
      </span>
    </div>
  );
}

export { Status };
